/* Collector's Cage - replaces the scripts of the uninstalled Bloggle app on old blog articles.
   1. Images: Bloggle kept image URLs in data-src / data-srcset (lazysizes). They are promoted to src / srcset
      and the browser lazy-loads them natively.
   2. FAQ blocks: accordion. Without this script the answers simply stay visible (see cc-bloggle.css).
   3. Product cards: the hard-coded "DKK" / "DKK>" price label is shown as "kr", as Bloggle's script did.
   No network requests, no third-party code. Loaded by sections/main-article.liquid only for Bloggle articles. */
(function () {
  'use strict';

  function images() {
    var imgs = document.querySelectorAll('img.lazybloggle[data-src], img.lazybloggle[data-srcset]');
    var todo = [], i;
    for (i = 0; i < imgs.length; i++) {           // read layout first, then write
      var img = imgs[i], w = 0;
      if (img.getAttribute('data-srcset') && img.parentNode) w = img.parentNode.clientWidth || 0;
      todo.push([img, w]);
    }
    for (i = 0; i < todo.length; i++) {
      var el = todo[i][0], src = el.getAttribute('data-src'), set = el.getAttribute('data-srcset');
      if (!el.hasAttribute('loading')) el.setAttribute('loading', 'lazy');
      el.setAttribute('decoding', 'async');
      if (set && !el.getAttribute('srcset')) {
        el.setAttribute('sizes', todo[i][1] > 0 ? Math.ceil(todo[i][1]) + 'px' : '(min-width: 850px) 800px, 100vw');
        el.setAttribute('srcset', set);
      }
      if (src && !el.getAttribute('src')) el.setAttribute('src', src);
      el.classList.add('lazyloadedbloggle');
    }
  }

  function faq() {
    var qs = document.querySelectorAll('.bggle_faq .bggle--question');
    for (var i = 0; i < qs.length; i++) {
      (function (q) {
        var answer = q.nextElementSibling;
        if (!answer || !answer.classList.contains('reponse')) return;
        var icon = q.querySelector('.arrow__down--svg');
        var toggle = function () {
          var open = !answer.classList.contains('opened');
          answer.classList.toggle('opened', open);
          if (icon) icon.classList.toggle('opened', open);
          q.setAttribute('aria-expanded', open ? 'true' : 'false');
        };
        q.setAttribute('role', 'button');
        q.setAttribute('tabindex', '0');
        q.setAttribute('aria-expanded', 'false');
        q.addEventListener('click', toggle);
        q.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); toggle(); }
        });
      })(qs[i]);
    }
    var blocks = document.querySelectorAll('.bggle_faq');
    for (var k = 0; k < blocks.length; k++) blocks[k].classList.add('cc-faq-js');
  }

  function currency() {
    var spans = document.querySelectorAll('.custom-product .bloggle_product--price-currency');
    for (var i = 0; i < spans.length; i++) {
      if (/^\s*DKK\s*>?\s*$/i.test(spans[i].textContent)) spans[i].textContent = 'kr';
    }
  }

  function init() {
    var steps = [images, faq, currency];
    for (var i = 0; i < steps.length; i++) {
      try { steps[i](); } catch (e) { if (window.console) console.warn('cc-bloggle', e); }
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
